
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import _ from 'lodash'
import {Action} from 'vuex-class'
import {DOWNLOAD_INVOICE, FETCH_MY_LATEST_INVOICES} from '@/store/action-types'
import {InvoiceResponseItem, MyLatestInvoiceResponse} from '@/types/service-response'
import Moment from "moment";
import VueI18n from "vue-i18n";
import TranslateResult = VueI18n.TranslateResult;

@Component({
  components: {
    // PayBySquare
  }
})
export default class PaymentPage extends Vue {
  private invoice: InvoiceResponseItem | null = null
  private downloadInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarMessage: TranslateResult | string = ''
  private snackBarColor: string = ''

  @Action(FETCH_MY_LATEST_INVOICES) fetchInvoices!: ({ (): Promise<MyLatestInvoiceResponse> })
  @Action(DOWNLOAD_INVOICE) downloadInvoice!: ({ (invoice: InvoiceResponseItem): Promise<void> })

  get sumPrice(): string {
    return this.formatPrice(this.invoice!.priceItemSum)
  }

  get amountFromWallet(): string {
    return this.formatPrice(this.invoice!.amountFromWallet)
  }

  get amountFromDept(): string {
    return this.formatPrice(this.invoice!.amountFromDept)
  }

  get totalPrice(): string {
    return this.formatPrice(this.invoice!.priceTotal)
  }

  get cardLabel(): string {

    return Moment(this.invoice!.periodStart).format('D.M') + ' ' + '-' + ' ' + Moment(this.invoice!.periodEnd)
      .locale('sk-sk')
      .format('DD.MM.YYYY')
  }

  async onDownloadInvoiceButtonClick(): Promise<void> {
    if (this.invoice) {
      this.downloadInProgress = true

      try {
        await this.downloadInvoice(this.invoice)
      } catch (e) {
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('paymentPage.errorMessage')
        this.showSnackBar = true
      }
      finally {
        this.downloadInProgress = false
      }
    }
  }

  formatPrice(price: number): string {
    const formatter = new Intl.NumberFormat('sk-SK', {
      style: 'decimal',
      minimumFractionDigits: 2
    })

    return formatter.format(price / 100)
  }

  async fetchData(): Promise<void> {
    this.invoice = _.first(await this.fetchInvoices()) || null
  }

  mounted() {
    this.fetchData()
  }
}

